import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../component/ui/loader/data-not-found";
import { PlusIcon } from "lucide-react";
import { useApiCall } from "../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../component/icons/filter-funnel-01";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import CustomizeTabsPopup from "../../../component/table/customize-table";
import LayoutTopIcon from "../../../component/icons/layout-top";
import Tooltip from "../../../component/ui/tooltip";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableFilterReturn,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../component/table/table-layout";
import NewEditIcon from "../../../component/icons/action-edit-icon";
import AddLeadStatus from "./add-form";

const LeadStatusList = () => {
  const masterCheckboxRef = useRef();
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [tableHeader, setTableHeader] = useState([]);
  const [pageItemsCount, setPageItemsCount] = useState(10);
  const [showAddForm, setShowAddForm] = useState(false);
  const [editData, setEditData] = useState({});

  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
  }, []);

  const getData = async ({
    filter = filterReturn,
    page,
    page_quantity = pageItemsCount,
  }) => {
    if (!page) {
      setIsLoading(true);
    }
    let apiData = { page: page, page_quantity: 10 };
    let extraUrl = `?page=${page || 1}&page_quantity=${page_quantity}`;
    for (let i = 0; i < filter?.length; i++) {
      extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
    }

    try {
      const res = await apiCall({
        method: "get",
        url: `status-config/status-list${extraUrl}`,
        data: apiData,
      });
      if (page) {
        setApiData((prev) => [...prev, ...res.data]);
      } else {
        setApiData(res.data);
      }
      setTableHeader(res?.applied_headers);
      setSaveFilter(res?.custom_filters);

      setTablePagination(res?.pagination);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setEditData({});
    setShowAddForm(false);
    getData({});
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const filterModalData = [
    {
      name: "date_filter",
      label: "By Date",
      options: ["is", "between"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "Today", value: "today" },
        { label: "Yesterday", value: "yesterday" },
        { label: "This Week", value: "this_week" },
        { label: "This Month", value: "this_month" },
      ],
      dropdownKey: "label",
      dropdownVal: "value",
      betweenType: "date",
    },
  ];

  const tableRef = useRef(null);

  return (
    <>
      <div className={`${Style.mainBody}`}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>
             

              {/* HEADER */}
              <div className={Style.empDirectory_header}>
                <div className={Style.empDirectory_header_left}>
                  <TableFilterReturn
                    filterReturn={filterReturn}
                    onChange={(allFilter) => {
                      setFilterReturn(allFilter);
                      getData({ filter: allFilter });
                    }}
                  />
                </div>

                <div className={Style.empDirectory_header_right}>
                  <div className={Style.bpfl_action}>
                    <div
                      className={Style.bpfl_action}
                      onClick={() => {
                        setShowAddForm(true);
                      }}
                    >
                      <Tooltip
                        content={"Add Lead Status"}
                        position={"left center"}
                        className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
                      >
                        <div className={Style.icon}>
                          <PlusIcon size="1em" />
                        </div>
                      </Tooltip>
                    </div>

                    <Tooltip
                      className={Style.bpfl_actionItems}
                      content={"Table Filter"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${
                          filterReturn?.length ? Style.active : null
                        }`}
                        onClick={() => {
                          setShowModalFilterTable(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <FilterFunnel01Icon />
                        </div>
                      </div>
                    </Tooltip>

                    <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"Customize Table"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn}`}
                        onClick={() => {
                          setShowModalCustomizeTabs(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <LayoutTopIcon />
                        </div>
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>

              {/* BODY */}
              <div className={Style.empDirectory_body}>
                {isLoading ? (
                  <InnerLoader />
                ) : !apiData?.length ? (
                  <div className="flex justify-center items-center w-full h-full">
                    <DataNotFound title={"Lead Status"} />
                  </div>
                ) : (
                  <>
                    <TableCard ref={tableRef}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell header sticky>
                              <TableHeaderWrap>
                                <span className="pl-[50px]">Status Name</span>
                              </TableHeaderWrap>
                            </TableCell>
                            {tableHeader?.map((eachHead, index) =>
                              eachHead.is_visible === 1 &&
                              eachHead?.show == 1 ? (
                                <TableCell header key={index}>
                                  <TableHeaderWrap>
                                    <span>{eachHead?.value}</span>
                                  </TableHeaderWrap>
                                </TableCell>
                              ) : null
                            )}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {apiData?.map((eachList, index) => {
                            return (
                              <TableRow key={`${index}`}>
                                <TableCell sticky>
                                  <div
                                    className={`${Style.tableActionArea} !gap-4`}
                                  >
                                    <div className="flex items-center gap-3">
                                      <div className="font-medium leading-5">
                                        {eachList?.status_name}
                                      </div>
                                    </div>

                                    <div
                                      className={Style.tableActionAreaBtnGrpup}
                                    >
                                      <div
                                        className={
                                          "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                        }
                                        onClick={() => {
                                          setEditData(eachList);
                                          setShowAddForm(true);
                                        }}
                                      >
                                        <div
                                          className={Style.icon}
                                          style={{ color: "#FF9500" }}
                                        >
                                          <NewEditIcon className="h-4.5 w-4.5" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </TableCell>

                                {tableHeader?.map((eachHead, i) =>
                                  eachHead.is_visible === 1 &&
                                  eachHead?.show == 1 ? (
                                    <TableCell key={`${i}-${index}`}>
                                      {eachList[eachHead.key] ?? "-"}
                                    </TableCell>
                                  ) : null
                                )}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableCard>
                  </>
                )}
              </div>
              {!isLoading ? (
                apiData?.length > 0 ? (
                  <div
                    className={Style.table_footer}
                    style={{ alignItems: "center" }}
                  >
                    <div className={Style.table_footer_left}>
                      {`showing 1 to ${apiData?.length} of ${
                        tablePagination?.total || apiData?.length
                      }`}
                    </div>

                    {tablePagination ? (
                      <div className={Style.empDirectory_footer}>
                        {tablePagination?.next_page_url ? (
                          <button
                            className={Style.loadMoreBtn}
                            onClick={() => {
                              if (btnLoader) return;
                              // setPageCount(pageCount + 1);
                              setBtnLoader(true);
                              // filterData({ page: pageCount + 1, btnCall: true });
                              getData({
                                page: tablePagination?.next_page_url,
                              });
                            }}
                          >
                            {btnLoader ? (
                              <InnerLoader
                                className={Style.loader}
                                textStatus={false}
                              />
                            ) : (
                              "Load More"
                            )}
                          </button>
                        ) : null}
                      </div>
                    ) : null}

                    <div
                      className={`${Style.table_footer_left} ${Style.rightText}`}
                    ></div>
                  </div>
                ) : null
              ) : (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  <div className={Style.table_footer_left}>
                    <Skeleton width={"50%"} height={15} />
                  </div>

                  <div className={Style.empDirectory_footer}>
                    <Skeleton width={"180px"} height={40} />
                  </div>

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="status-config/status-list"
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeader}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeader(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeader(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="status-config/status-list"
        />
      )}

      {showAddForm && (
        <AddLeadStatus
          onError={onError}
          onSubmit={onSuccess}
          onClose={() => {
            setShowAddForm(false);
            setEditData({});
          }}
          editData={editData}
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default LeadStatusList;
